import { useMemo } from 'react';
import { SelectCitations, AvailableNewCitationsRowData } from './SelectCitations';
import { createAvailableNewCitationsColumns } from '../utils/tableColumns';
import { useAvailableNewCitations } from '../hooks';
import { Box, Button, Typography } from '@mui/material';
import { removeAllButtonSx } from '../styles';
import { addToOrderButtonSx } from './SyncAndPost';

// Constants
const TITLE = 'Available New Citations';
const DESCRIPTION =
  'Manual Submissions. We handle all email verifications and give you login details for all accounts created.';

export const AvailableNewCitations = () => {
  // Memoized table columns
  const columns = useMemo(() => createAvailableNewCitationsColumns(), []);

  // Use custom hook for all business logic
  const {
    tableData,
    selected,
    totalPrice,
    orderBy,
    order,
    handleSelect,
    handleSelectAll,
    handleRemoveAll,
    handleRequestSort,
    handleSelectMultiple
  } = useAvailableNewCitations();

  return (
    <SelectCitations<AvailableNewCitationsRowData>
      title={TITLE}
      description={DESCRIPTION}
      data={tableData}
      columns={columns}
      selected={selected.map((citation) => citation.citationSite)}
      totalPrice={totalPrice}
      onSelect={handleSelect}
      onSelectMultiple={handleSelectMultiple}
      onSelectAll={handleSelectAll}
      onRemoveAll={handleRemoveAll}
      orderBy={orderBy}
      order={order}
      onSort={handleRequestSort}
      getRowId={(row) => row.citationSite}
      actionButton={() => {
        // Check if all items are selected
        const allSelected = tableData.length > 0 && selected.length === tableData.length;

        if (allSelected) {
          return (
            <Button
              variant="outlined"
              color="primary"
              onClick={handleRemoveAll}
              sx={removeAllButtonSx}
            >
              Remove All
            </Button>
          );
        }

        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              const syntheticEvent = {
                target: { checked: true }
              } as React.ChangeEvent<HTMLInputElement>;
              handleSelectAll(syntheticEvent);
            }}
            sx={addToOrderButtonSx}
          >
            Add To Order
          </Button>
        );
      }}
      noDataFallbackUI={() => {
        return (
          <Box
          sx={{
            textAlign: 'center',
          }}
          >
            <Typography>No available new citations found</Typography>
          </Box>
        );
      }}
    />
  );
};

